import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Region  {
    _originalTypeClassName = "zERP.BO.Region";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Region.translate = translateService;
}
this.Children = [];
this.Id = null;
this.Name = null;
this.NameInUpper = null;
this.Type = null;
this.EU_Code = null;
this.NameInEnglish = null;
this.Code_ = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
NameInUpper:any;
Type:any;
EU_Code:any;
NameInEnglish:any;
Code_:any;
Children:any;
Parent:any;
static setChildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.Children == null) $this.Children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Children.length > 0) {
                    Domain.Region.removeChildren($this, $this.Children[0]);
                }

                Domain.Region.addManyChildren($this, copyItems);
            }
static addManyChildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Region.addChildren($this, items[i]);
                }
            }
static addChildren = ($this, item) => {
                if ($this.Children == null) $this.Children = [];
                if (item == null || $this.Children.indexOf(item) > -1) return;
                $this.Children.push(item);
if (item.Parent != $this) {
Domain.Region.setParent(item, $this);
}
}
static addRangeChildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Region.addChildren($this, item));
            }
static removeChildren = ($this, item) => {
                if ($this == null || $this.Children == null || $this.Children.indexOf(item) === -1) return;
                var _index = $this.Children.indexOf(item);
                $this.Children.splice(_index, 1);
item.Parent = null;
}
static clearChildren = ($this) => { $this.Children = null; }
static setParent = ($this, value) => {
var oldValue = $this.Parent;
$this.Parent = value;
if (value != null) {
if (oldValue != null) {
Domain.Region.removeChildren(oldValue, $this);
}
Domain.Region.addChildren(value, $this);
}
}

static GetClassName(): any{return "Region";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}